






































































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { bleDeviceNames, BleDeviceTypes } from '@/constants/ble'
import { No10DeviceParams } from '@/types/ble'
import { EventEmitter } from 'events'
import BleProvider from '@/ble'
import { BLEDevice } from '@/ble/types'

enum EventTypes {
  MODAL_CLOSE
}

@Component({
  components: {
    EcgSettingModal: () =>
      import('@/components/patient/bleSetting/connection/EcgSetting.vue')
  }
})
export default class BleSettingConnection extends Vue {
  readonly DEVICE_TYPE_ECG_SERVICE = BleDeviceTypes.ECG_SERVICE

  $store!: ExStore
  bleDeviceNames = bleDeviceNames
  connectionPending: { [address: string]: boolean } = {}
  events = new EventEmitter()

  settingModalProps: {
    [KEY in BleDeviceTypes]?: BLEDevice
  } = {
    [BleDeviceTypes.ECG_SERVICE]: undefined
  }

  get bleDevices() {
    return this.$store.getters['ble/devices']
  }

  get autoSending() {
    return this.$store.getters['ble/autoSending']
  }

  set autoSending(sending: boolean) {
    this.$store.dispatch('ble/updateAutoSending', sending)
  }

  get connectedDevices() {
    const devices = this.bleDevices
    return Object.keys(devices)
      .filter(addr => {
        return devices[addr].logicalConnected
      })
      .sort((a1, a2) => {
        return devices[a1].deviceType - devices[a2].deviceType
      })
      .map(addr => devices[addr])
  }

  get disconnectedDevices() {
    const devices = this.bleDevices
    return Object.keys(devices)
      .filter(addr => {
        return !devices[addr].logicalConnected
      })
      .sort((a1, a2) => {
        return devices[a1].deviceType - devices[a2].deviceType
      })
      .map(addr => devices[addr])
  }

  hasSetting(type: BleDeviceTypes) {
    switch (type) {
      case BleDeviceTypes.ECG_SERVICE:
        return true
      default:
        return false
    }
  }

  async handleConnect(address: string) {
    if (this.connectionPending[address]) {
      return
    }

    try {
      this.connectionPending[address] = true

      const params =
        this.bleDevices[address].deviceType ===
        BleDeviceTypes.BODY_COMPOSITION_MONITOR
          ? ({ userControl: 'add' } as No10DeviceParams)
          : {}

      await this.$store.dispatch(
        'ble/connect',
        Object.assign(params, { address })
      )
    } catch (error) {
      console.error(error)
    } finally {
      this.connectionPending[address] = false
    }
  }

  async handleDisconnect(address: string) {
    if (this.connectionPending[address]) {
      return
    }

    try {
      this.connectionPending[address] = true

      await this.$store.dispatch('ble/disconnect', { address })
    } catch (error) {
      console.error(error)
    } finally {
      this.connectionPending[address] = false
    }
  }

  async handleClickSettingButton(type: BleDeviceTypes) {
    if (type in this.settingModalProps === false) {
      throw new Error(`type ${type} not supported!`)
    }

    const device = BleProvider.getDeviceByDeviceType(type)

    if (!device) {
      throw new Error('Device not found!')
    }

    this.$set(this.settingModalProps, type, device)

    await new Promise(resolve =>
      this.events.once(EventTypes.MODAL_CLOSE, resolve)
    )

    this.$set(this.settingModalProps, type, undefined)
  }

  handleCloseSettingModal() {
    this.events.emit(EventTypes.MODAL_CLOSE)
  }

  created() {
    this.$store.dispatch('ble/startScan')
  }

  destroyed() {
    this.$store.dispatch('ble/deleteUnconnectedDevices')
    this.$store.dispatch('ble/stopScan')
  }
}
